export const WhiteNonWhiteCategoryFactory = () => {
  return [
    { name: "Non White", field: "nonWhite", color: '#e94b35' },
    { name: "White", field: "white", color: '#e87e04' }
  ]
}